@let variant = this.variant();

<div class="preview flex-column g-space-md">
  <!-- même rendu que le message et la signature, au lieu d'un innerHTML brut -->
  <div class="preview__body">
    <cam-cms-editor-blocks [blocks]="variant.jsonBodyParsed ?? []"></cam-cms-editor-blocks>
  </div>

  @if (variant.documentIds && variant.documentIds.length > 0) {
    <div class="preview__documents flex-column g-space-xs">
      <cam-text size="xs">
        {{ 'communication.message.attachments.title' | translate }}
      </cam-text>
      <cam-documents-list [documentsIds]="variant.documentIds"></cam-documents-list>
    </div>
  }
</div>
